import { useState } from "react";
import { useSnackbar } from "notistack";

import { Button, FormControl, MenuItem, Select, Stack, Switch, TextField } from "@mui/material";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";

interface AllMasksRequest {
    data: AllMasksData;
    error: IError;
}
interface AllMasksData {
    masks: string[];
}

interface CreateMaskStructureRequestModel {
    fromExisting: boolean;
    existingName: string;
    newName: string;
}

interface CreateMaskStructureResponse {
    data: CreateMaskStructureData;
    error: IError;
}
interface CreateMaskStructureData {
    status: string;
}

function CreateMaskStructure() {
    const { enqueueSnackbar } = useSnackbar();

    const [allMasks, setAllMasks] = useState<string[]>([]);
    const [selectedMask, setSelectedMask] = useState<string>("");

    const [fromExisting, setFromExisting] = useState<boolean>(false);

    const [maskName, setMaskName] = useState<string>("");

    function SelectForExisting(value: any) {
        var checked = value.target.checked;
        setFromExisting(checked);

        if (checked && allMasks.length === 0) {
            GetAllMasks();
        }
    }

    const GetAllMasks = async () => {
        try {
            const response: AllMasksRequest = await api.get("api/Admin/GetAllMasks", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                setAllMasks(response.data.masks)
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    const CreateMaskStructure = async () => {

        var body: CreateMaskStructureRequestModel = {
            fromExisting: fromExisting,
            existingName: selectedMask,
            newName: maskName
        };

        try {
            const response: CreateMaskStructureResponse = await api.post("api/Admin/CreateMaskStructure", {
                json: body,
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                enqueueSnackbar("Created!", { variant: "success" })
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    function HandleMaskNameChange(event: any) {
        var value = event.target.value;
        value = value.replace('&', '');
        setMaskName(value);
    }

    return (
        <Stack direction={"row"}>
            <Stack
                direction={"column"}
                alignItems={"start"}>
                {/* Create invoice for all clients*/}
                <Stack
                    direction={"row"}
                    alignItems={"center"} >
                    <p style={{ width: '200px' }}>Use existing as example? </p>
                    <Switch
                        checked={fromExisting}
                        onChange={SelectForExisting}
                        size="small" />
                </Stack>

                {/* Billing per */}
                {fromExisting ?
                    <Stack
                        direction={"row"}
                        alignItems={"center"}>
                        <p style={{ width: '200px' }}>Select from existing: </p>
                        <FormControl sx={{ minWidth: "245px" }}>
                            <Select
                                value={selectedMask}
                                onChange={(newValue: any) => { setSelectedMask(newValue.target.value); }}
                                size="small">
                                {allMasks.map((item, index) =>
                                    <MenuItem
                                        key={index}
                                        value={item}>
                                        {item}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                    : null}

                <Stack
                    direction={"row"}
                    alignItems={"center"} >
                    <p style={{ width: '200px' }}>Mask structure name: </p>
                    <TextField
                        value={maskName}
                        onChange={HandleMaskNameChange}
                        sx={{ minWidth: "245px" }}
                        size="small" />
                </Stack>

                <Button
                    variant="outlined"
                    onClick={CreateMaskStructure}
                    sx={{ marginTop: "15px" }}>
                    Create new mask structure
                </Button>
            </Stack>
        </Stack>
    )
}

export default CreateMaskStructure;